import React from "react";
import PropTypes from "prop-types";

import ReportBook from "../containers/report_book";
import PrimaryFilter from "../containers/primary_filter";
import ViewType from "../containers/view_type";
import SecondaryFilters from "../containers/secondary_filters";
import HackyAjaxyStuff from "../utils/ajaxy_stuff";

class ForecastsFiltersContainer extends React.Component {
  childUpdated = () => {
    document.getElementById("which_button_clicked").value = "Search";
    HackyAjaxyStuff.triggerFormSubmit(100);
  }

  render () {
    if (!this.props.filterObjects) return(<div></div>);

    const restrictPrimaryFilters = (e) => (e.prevent_primary_or_secondary !== "primary" && e.report_book === this.props.selectedBook);
    const primaryFilters = this.props.filterObjects.filter(restrictPrimaryFilters);
    const restrictSecondaryFilters = (e) => (e.prevent_primary_or_secondary !== "secondary" && e.report_book === this.props.selectedBook);
    const secondaryFilters = this.props.filterObjects.filter(restrictSecondaryFilters);
    const viewObjects = this.props.viewObjects.filter((e) => (e.report_book === this.props.selectedBook));

    return (
      <div>
        <h4>Choose forecast</h4>
        <ReportBook onUpdate={this.childUpdated} filterObjects={this.props.filterObjects} reportBookOptions={this.props.reportBookOptions} />
        <PrimaryFilter onUpdate={this.childUpdated} filterObjects={primaryFilters}  viewObjects={viewObjects} />
        <ViewType onUpdate={this.childUpdated} viewObjects={viewObjects} filterObjects={primaryFilters} />
        <SecondaryFilters onUpdate={this.childUpdated} viewObjects={viewObjects} filterObjects={secondaryFilters} allFilterObjects={this.props.filterObjects} />
      </div>
    );
  }
}

ForecastsFiltersContainer.propTypes = {
  filterObjects: PropTypes.arrayOf(PropTypes.object),
  viewObjects: PropTypes.arrayOf(PropTypes.object),
  reportBookOptions: PropTypes.arrayOf(PropTypes.object),
  selectedBook: PropTypes.string,
};

export default ForecastsFiltersContainer;
